import { RequestMethodsEnum as o } from "@systemeio/util";
import { useFetch as i } from "../../../utils/http-client.mjs";
const c = () => {
  const { fetcher: t, isFetching: e } = i({
    method: o.post,
    unprocessableContentHandler: () => {
    }
  });
  return { handleOptin: (n) => t("/api/public/digital-store/opt-in", n), isFetching: e };
};
export {
  c as useHandleOptin
};
